// extracted by mini-css-extract-plugin
export default {"card":"card__fyodv","cardHeader":"cardHeader__13yPS","cardHeaderText":"cardHeaderText__hamOh"};